import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export default function ConfirmationDialog({
  isOpen,
  onClose,
  confirmAction,
  headText,

  loading,
  text,
}: {
  isOpen: boolean;
  onClose: any;
  confirmAction: any;
  loading: boolean;
  headText: string;
  text: string;
}) {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{headText}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            background: '#fff',
            color: '#191A1C',
            justifyContent: 'center',
            fontSize: '16px',
          }}
          onClick={() => {
            onClose();
          }}
          disabled={loading}
        >
          No
        </Button>
        <Button
          sx={{
            justifyContent: 'center',
            fontSize: '16px',
          }}
          onClick={() => {
            confirmAction();
            onClose();
          }}
          disabled={loading}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// export default ConfirmationDialog;
